import { Button, Icon, NonIdealState, Spinner } from '@blueprintjs/core';
import cx from 'classnames';
import React, { useEffect, useState } from 'react';

import * as api from 'api';

import { useAppDispatch, useAppSelector } from 'hooks';
import { setError } from 'store/general';
import { fetchJudges } from 'store/registration';
import styles from './styles.module.scss';

const emailPattern = new RegExp('^[^@]+@[^@]+.[^@]+$');

export default function JudgesTable() {
  const [addingNew, setAddingNew] = useState(false);
  const [newJudgeName, setNewJudgeName] = useState('');
  const [newJudgeEmail, setNewJudgeNameEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const dispatch = useAppDispatch();

  const judges = useAppSelector((state) => state.registration.judges) || [];

  async function reloadData() {
    setLoading(true);
    await dispatch(fetchJudges());
    setLoading(false);
  }

  useEffect(() => {
    reloadData();
  }, []);

  const isValidEmail = newJudgeEmail.match(emailPattern);

  function resetInput() {
    setNewJudgeName('');
    setNewJudgeNameEmail('');
    setAddingNew(false);
  }

  async function saveNewJudge() {
    setLoading(true);
    try {
      await api.addJudge({ name: newJudgeName, email: newJudgeEmail });
      resetInput();
    } catch (err) {
      dispatch(setError('Failed to add judge'));
      console.error('Failed to add judge', err);
    }

    await reloadData();
    setLoading(false);
  }

  if (loading && !judges.length) {
    return <NonIdealState icon={<Spinner />} title="loading" />;
  }

  return (
    <div className={styles.judges}>
      <h3>Judges</h3>
      <div className={cx(styles.headerRow, styles.judgesTableGrid)}>
        <div>Name</div>
        <div>Email</div>
        <div>Has logged in</div>
      </div>

      <div className={styles.judgesTableGrid}>
        {judges.map((judge) => (
          <React.Fragment key={judge.email}>
            <div className={styles.judgeName}>
              {judge.name}
              {judge.isAdmin && <em className={styles.judgeAdmin}> (Admin)</em>}
            </div>
            <div className={styles.judgeEmail}>{judge.email}</div>

            {<Icon icon={judge.loggedIn ? 'tick' : 'minus'} />}
          </React.Fragment>
        ))}

        {addingNew ? (
          <>
            <input
              type="text"
              autoFocus
              placeholder="Name"
              value={newJudgeName}
              onChange={(e) => setNewJudgeName(e.target.value)}
              className={styles.newJudgeInput}
            />
            <input
              type="text"
              placeholder="Email"
              value={newJudgeEmail}
              onChange={(e) => setNewJudgeNameEmail(e.target.value)}
              className={styles.newJudgeInput}
            />
            <div>
              <Button
                disabled={loading}
                text="Discard"
                onClick={() => {
                  setAddingNew(false);
                  setNewJudgeName('');
                }}
              />

              <Button
                text="Save"
                intent="success"
                disabled={!newJudgeName || !isValidEmail}
                onClick={saveNewJudge}
                loading={loading}
              />
            </div>
          </>
        ) : (
          <Button
            className={styles.addNewJudge}
            intent="success"
            icon="plus"
            text="New judge"
            onClick={() => setAddingNew(true)}
          />
        )}
      </div>
    </div>
  );
}
